<template>
    <b-row>
        <b-col sm="12">
            <b-card>
                <b-row class="pt-sm-1">
                    <b-col sm="1">
                        <span class="card-title wise-card-title">검색 조건</span>
                    </b-col>
                    <b-col sm="1"><strong>검색어</strong></b-col>
                    <b-col sm="8">
                        <b-form-input v-model="queryParams.keyword" placeholder=""
                            v-on:keyup="$event.keyCode === 13 ? findCompanyUser() : ''"></b-form-input>
                    </b-col>
                    <b-col sm="2" style="text-align: center;">
                        <b-button variant="primary" style="width: 100%;" v-on:click="findCompanyUser()">검색</b-button>
                    </b-col>
                </b-row>
                <b-row class="pt-sm-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1"><strong>상품적용일자</strong></b-col>
                    <b-col sm="3">
                        <date-picker v-model="fullDateTmp" 
                                    type="date" 
                                    range 
                                    placeholder="조회기간 선택" 
                                    :lang="datepickerLang" 
                                    @change="handleDateRangeChange"
                        />
                    </b-col>
                    <b-col sm="4">
                        <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('ALL')">전체</button>
                        <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1WEEK')">1주일</button>
                        <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('1MONTH')">1개월</button>
                        <button type="button" class="btn btn-outline-primary" v-on:click="dateRange('6MONTH')">6개월</button>
                        <button type="button" class="btn btn-outline-primary" style="width: 61.72px;" v-on:click="dateRange('1YEAR')">1년</button>
                    </b-col>
                </b-row>
                <b-row class="pt-sm-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1"><strong>상품기간</strong></b-col>
                    <b-col sm="10" style="display: inline-flex;">
                        <b-form-checkbox v-model="isCheckPeriodTypeSearch" style="padding-right: 15px;" @change="allCheckPeriodTypeSearch">전체</b-form-checkbox>
                        <b-form-checkbox-group v-model="queryParams.periodTypeSearchArr" @click.native="isCheckPeriodTypeSearch = false">
                            <template v-for="(item, index) in periodTypeOptions">
                                <b-form-checkbox :value="item.item_code">{{item.item_name}} 개월</b-form-checkbox>
                            </template>
                        </b-form-checkbox-group>
                    </b-col>
                </b-row>
                <b-row class="pt-sm-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1"><strong>다운로드형식</strong></b-col>
                    <b-col sm="10" style="display: inline-flex;">
                        <b-form-checkbox v-model="isCheckDownloadTypeSearch" style="padding-right: 15px;" @change="allCheckDownloadTypeSearch">전체</b-form-checkbox>
                        <b-form-checkbox-group v-model="queryParams.downloadTypeSearchArr" @click.native="isCheckDownloadTypeSearch = false">
                            <template v-for="(item, index) in downloadTypeOptions">
                                <b-form-checkbox :value="item.item_code">{{item.item_name}}</b-form-checkbox>
                            </template>
                        </b-form-checkbox-group>
                    </b-col>
                </b-row>
                <b-row class="pt-sm-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1"><strong>사용자구분</strong></b-col>
                    <b-col sm="10" style="display: inline-flex;">
                        <b-form-checkbox v-model="isCheckPTypeSearch" style="padding-right: 15px;" @change="allCheckPTypeSearch">전체</b-form-checkbox>
                        <b-form-checkbox-group v-model="queryParams.pTypeSearchArr" @click.native="isCheckPTypeSearch = false">
                            <template v-for="(item, index) in pTypeOptions">
                                <b-form-checkbox :value="item.item_code">{{item.item_name}}</b-form-checkbox>
                            </template>
                        </b-form-checkbox-group>
                    </b-col>
                </b-row>
                <b-row class="pt-sm-2">
                    <b-col sm="1"></b-col>
                    <b-col sm="1"><strong>상태</strong></b-col>
                    <b-col sm="10" style="display: inline-flex;">
                        <b-form-checkbox v-model="isCheckAuthStateTypeSearch" style="padding-right: 15px;" @change="allCheckAuthStateTypeSearch">전체</b-form-checkbox>
                        <b-form-checkbox-group v-model="queryParams.authStateTypeSearchArr" @click.native="isCheckAuthStateTypeSearch = false">
                            <template v-for="(item, index) in authStateTypeOptions">
                                <b-form-checkbox :value="item.item_code">{{item.item_name}}</b-form-checkbox>
                            </template>
                        </b-form-checkbox-group>
                    </b-col>
                </b-row>
            </b-card>
        </b-col>
    </b-row>
</template>
<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import _ from 'lodash'

import { EventBus } from "../../../event-bus";

const moment = require("moment");

export default {
    name: "companyUserSearch",
    props: {
        queryParams: {
            keyword: {
                type: String,
            },
            pTypeSearchArr: {
                type: Array,
            },
            periodTypeSearchArr: {
                type: Array,
            },
            downloadTypeSearchArr: {
                type: Array,
            },
            authStateTypeSearchArr: {
                type: Array,
            }
        },
        fullDate: {
            type: Array,
        },
    },
    data() {
        return {
            datepickerLang: {
                yearFormat: "YYYY년",
                monthFormat: "M월",
                days:["일","월","화","수","목","금","토"]
            },
            fullDateTmp: [],
            isCheckPeriodTypeSearch: false,
            periodTypeOptions: [],
            isCheckDownloadTypeSearch: false,
            downloadTypeOptions: [],
            isCheckPTypeSearch: false,
            pTypeOptions: [],
            isCheckAuthStateTypeSearch: false,
            authStateTypeOptions: [],
            
        }
    },
    mounted() {
        this.findCodesList();
    },
    watch: {
    },
    components: {
        DatePicker,
    },
    methods: {
        findCompanyUser() {
            EventBus.$emit('callFindCompanyUser');
        },
        // 날짜 정의
        dateRange(flag) {
            let endDate;
            let startDate;
            if(this.fullDateTmp.length === 0){
                endDate = new Date();
                startDate = new Date();
            }else{
                endDate = this.fullDateTmp[1];
                startDate = _.clone(this.fullDateTmp[1]);
            }

            if(flag == '1WEEK'){
                startDate.setDate(endDate.getDate() - 7);
            }else if(flag == '1MONTH'){
                startDate.setMonth(endDate.getMonth() - 1);
            }else if(flag == '6MONTH'){
                startDate.setMonth(endDate.getMonth() - 6);
            }else if(flag == '1YEAR'){
                startDate.setFullYear(endDate.getFullYear() - 1);
            }
            this.fullDateTmp = [startDate, endDate];
            if(flag == 'ALL'){
                this.fullDateTmp = [];
            }
            this.handleDateRangeChange();
        },
        handleDateRangeChange() {
            this.$parent.fullDate = this.fullDateTmp;
        },
        findCodesList() {
            var token = sessionStorage.getItem("myToken");
            // PRDT_PERIOD(상품기간)
            this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=PRDT_PERIOD')
            .then((result) => {
                    const { data } = result;
                    this.periodTypeOptions = data;
                    // console.log(data);
            });

            // AUTH_DOWNLOAD_TYPE(계정권한 다운로드 형식)
            this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=AUTH_DOWNLOAD_TYPE')
            .then((result) => {
                    const { data } = result;
                    this.downloadTypeOptions = data;
            });

            // PRDT_TYPE(상품구분) > PRDT_TYPE_2(계정상품)
            this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=PRDT_TYPE_2')
            .then((result) => {
                    const { data } = result;
                    this.pTypeOptions = data;
            });

            // AUTH_STATE_TYPE(권한 상태)
            this.$http.get('/api/select/itemCodeList?access_token='+token + '&parentCode=AUTH_STATE_TYPE')
            .then((result) => {
                    const { data } = result;
                    this.authStateTypeOptions = data;
            });
        },
        allCheckPeriodTypeSearch() {
            this.isCheckPeriodTypeSearch = !this.isCheckPeriodTypeSearch;
            if(this.isCheckPeriodTypeSearch){
                this.queryParams.periodTypeSearchArr = [];
                this.periodTypeOptions.forEach((data) => {
                    this.queryParams.periodTypeSearchArr.push(data.item_code);
                });
            }else{
                this.queryParams.periodTypeSearchArr = [];
            }
        },
        allCheckDownloadTypeSearch() {
            this.isCheckDownloadTypeSearch = !this.isCheckDownloadTypeSearch;
            if(this.isCheckDownloadTypeSearch){
                this.queryParams.downloadTypeSearchArr = [];
                this.downloadTypeOptions.forEach((data) => {
                    this.queryParams.downloadTypeSearchArr.push(data.item_code);
                });
            }else{
                this.queryParams.downloadTypeSearchArr = [];
            }
        },
        allCheckPTypeSearch() {
            this.isCheckPTypeSearch = !this.isCheckPTypeSearch;
            if(this.isCheckPTypeSearch){
                this.queryParams.pTypeSearchArr = [];
                this.pTypeOptions.forEach((data) => {
                    this.queryParams.pTypeSearchArr.push(data.item_code);
                });
            }else{
                this.queryParams.pTypeSearchArr = [];
            }
        },
        allCheckAuthStateTypeSearch() {
            this.isCheckAuthStateTypeSearch = !this.isCheckAuthStateTypeSearch;
            if(this.isCheckAuthStateTypeSearch){
                this.queryParams.authStateTypeSearchArr = [];
                this.authStateTypeOptions.forEach((data) => {
                    this.queryParams.authStateTypeSearchArr.push(data.item_code);
                });
            }else{
                this.queryParams.authStateTypeSearchArr = [];
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/views/user/companyUserList/component/CompanyUserSearch.vue